import { HeroSection } from "@/components/ui/hero-section-4";

const Hero = () => {
  return (
    <HeroSection />
  );
};

export default Hero;
